webpackJsonp([79],{

/***/ 1256:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1257);


/***/ }),

/***/ 1257:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(174);

var _datetime2 = _interopRequireDefault(_datetime);

var _enCa = __webpack_require__(773);

var _enCa2 = _interopRequireDefault(_enCa);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('en-ca', _enCa2.default);

/***/ })

},[1256]);


// WEBPACK FOOTER //
// app/datetime.en-ca-aa84cac43276822b234a.js